<!--
 * @Author: M.D.
 * @Date: 2019-12-09 13:59:04
 * @LastEditors  : M.D.
 * @Description: 首页
 * @Remarks:
 -->
<template>
  <div class="base-index">
    <!-- 轮播图 -->
    <div class="carousel-wrapper">
      <el-carousel
        style="margin: 0"
        height="740px"
        :autoplay="true"
        :interval="3000"
        trigger="click"
        paginationColor="#FFFFFF"
        paginationActiveColor="#31A826"
      >
        <el-carousel-item
          style="height: 740px"
          class="slide-cls"
          v-for="i in carouselArr"
          :key="i.id"
        >
          <img
            @click="goADLink(i)"
            :src="i.pics"
            alt=""
            :onerror="errImgDefault"
          />
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 四大功能 -->
    <div class="first_m" :style="{ backgroundImage: 'url(' + bgimf + ')' }">
      <div class="idx-l-item">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/a.png" alt="" />
          <div class="idx-l-i-txt">发票真伪查询</div>
        </div>
      </div>

      <div class="idx-l-item">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/e.png" alt="" />
          <div class="idx-l-i-txt">发票综合服务平台</div>
        </div>
      </div>

      <div class="idx-l-item">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/f.png" alt="" />
          <div class="idx-l-i-txt">四川省电子税务局</div>
        </div>
      </div>

      <div class="idx-l-item">
        <div
          class="idx-l-item-w"
          onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
        >
          <img src="@/assets/image/g.png" alt="" />
          <div class="idx-l-i-txt">开票软件下载</div>
        </div>
      </div>
    </div>
    <!-- 最新资讯 -->
    <div class="idx-news-wr">
      <div class="newstext">最新资讯</div>
      <div class="news_h"></div>
      <div class="newset">NEWEST</div>

      <!-- <idx-sec mTitle="最新资讯" moreLinkName="news" sTitle="News">
          </idx-sec> -->
      <div class="news-content">
        <el-row>
          <el-col :span="11" v-if="hotNewsArr[0]">
            <div class="idx-nc-l bShadow-6" @click="newsDetail(hotNewsArr[0])">
              <div class="nc-h-l-img-w">
                <img
                  :src="tImgUrl(hotNewsArr[0] && hotNewsArr[0].pics[0])"
                  alt=""
                  :onerror="errImgDefault"
                />
              </div>
              <div class="nc-h-l-title">{{ hotNewsArr[0].title }}</div>
              <div class="nc-h-l-brief">{{ hotNewsArr[0].brief }}</div>
            </div>
          </el-col>
          <el-col :span="12" :offset="1">
            <div class="idx-nc-r" v-if="restHotNews.length > 0">
              <div
                class="idx-h-r-item bShadow-6"
                v-for="i in restHotNews"
                :key="i.id"
                @click="newsDetail(i)"
              >
                <div class="idx-h-r-i-title">{{ i.title }}</div>
                <div class="idx-h-r-i-brief">{{ i.brief }}</div>
                <div class="idx-h-r-i-date">{{ i.releaseTime }}</div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="links bShadow-5">
        <div class="idx-l-item">
          <div
            class="idx-l-item-w"
            onClick="window.open('https://inv-veri.chinatax.gov.cn/')"
          >
            <img src="@/assets/image/fake_pic.png" alt="" />
            <div class="idx-l-i-txt">发票真伪查询</div>
          </div>
        </div>
        <div class="idx-l-item">
          <div
            class="idx-l-item-w"
            onClick="window.open('https://fpdk.sichuan.chinatax.gov.cn/')"
          >
            <img src="@/assets/image/fake_pic.png" alt="" />
            <div class="idx-l-i-txt">发票综合服务平台</div>
          </div>
        </div>
        <div class="idx-l-item">
          <div
            class="idx-l-item-w"
            onClick="window.open('https://etax.sichuan.chinatax.gov.cn/')"
          >
            <img src="@/assets/image/fake_pic.png" alt="" />
            <div class="idx-l-i-txt">四川省电子税务局</div>
          </div>
        </div>
        <div class="idx-l-item">
          <div
            class="idx-l-item-w"
            onClick="window.open('http://118.121.199.216:888/downcode/fpcj?file=jskpinstall.rar&force=1')"
          >
            <img src="@/assets/image/fake_pic_1.png" alt="" />
            <div class="idx-l-i-txt">开票软件下载</div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 我们的优势 -->
    <div class="w_youshi" :style="{ backgroundImage: 'url(' + cityurl + ')' }">
      <div class="newstext">我们的优势</div>
      <div class="news_h"></div>
      <div class="newset">OUR ADVANTAGES</div>
      <div class="train-content">
        <div class="item_imgclass">
          <img src="@/assets/image/yzfu.png" alt="" />
        </div>
        <div class="item_imgclass">
          <img src="@/assets/image/dgqd.png" alt="" />
        </div>
        <div class="item_imgclass">
          <img src="@/assets/image/xwgj.png" alt="" />
        </div>
        <div class="item_imgclass">
          <img src="@/assets/image/qzgk.png" alt="" />
        </div>
        <div class="item_imgclass">
          <img src="@/assets/image/dljz.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 精品推荐 -->
    <div class="idx-train-wr">
      <!-- <idx-sec mTitle="精品推荐" sTitle="Recommended" :needMore="false">
          </idx-sec> -->
      <div class="newstext">精品推荐</div>
      <div class="news_h"></div>
      <div class="newset">RECOMMENDED</div>

      <div class="train-content">
        <product-list
          :dataList="recmdList"
          :showOther="true"
          :wpercent="4"
        ></product-list>
      </div>
    </div>
    <!-- 最新培训 -->
    <div class="zxpx" :style="{ backgroundImage: 'url(' + zxpxurl + ')' }">
      <div class="newstext">最新培训</div>
      <div class="news_h"></div>
      <div class="newset">TRAINING</div>
      <div class="z_lunbo">
        <el-carousel
          style="width: 950px; margin: auto"
          arrow="never"
          :interval="4000"
          type="card"
          height="650px"
          ref="cardShow"
          indicator-position="none"
        >
          <el-carousel-item
            class="slide-cls"
            v-for="i in latestTrainList"
            :key="i.id"
          >
            <img
              @click="goGdsDetail(i)"
              style="height: 650px; width: 100%"
              :src="tImgUrl(i.image.split(',')[0])"
              alt=""
            />
          </el-carousel-item>
        </el-carousel>
        <div class="next_l lunbo_l" @click="toLeftImg('left')">
          <i class="el-icon-arrow-left jiantou"></i>
        </div>
        <div class="next_l lunbo_r" @click="toLeftImg('right')">
          <i class="el-icon-arrow-right jiantou"></i>
        </div>
      </div>

      <div class="seemore" @click="goMore">
        查看更多<i class="el-icon-d-arrow-right"></i>
      </div>

      <!-- <idx-sec mTitle="最新培训" sTitle="Training" moreLinkName="qypx">
          </idx-sec>
          <div class="train-content">
            <product-list :dataList="latestTrainList"></product-list>
          </div> -->
    </div>
  </div>
</template>

<script>
import { Carousel, Slide } from 'vue-carousel'
import IdxSec from '@/components/idx-sec'
// import RightFloatBar from '@/components/right-float-bar'
import ProductList from '@/components/product-list'
import API from '@/api/api'
import { mapGetters } from 'vuex'

export default {
  props: {},
  data() {
    return {
      bgimf: require('@/assets/image/bg.jpg'),
      cityurl: require('@/assets/image/city.jpg'),
      zxpxurl: require('@/assets/image/zxpx.jpg'),
      carouselArr: [
        { pics: require('@/assets/image/default_img.jpg'), id: 1, uri: '' },
      ],
      hotNewsArr: [{ pics: [] }],
      latestTrainList: [],
      recmdList: [],
      count: 10,
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'curLoc']),
    restHotNews() {
      return this.hotNewsArr.slice(1, 4)
    },
  },
  created() {
    this.initIdxPage()
  },
  mounted() {
    if (this.$route.params.type != null && this.$route.params.type == 2) {
      //新闻
      this.clickJumpToNews(this.$route.params.productId)
    } else if (this.$route.params.productId != null) {
      this.clickJump(this.$route.params.productId)
    }
  },
  activated() {},
  deactivated() {},
  watch: {
    //根据选定的区域重新加载产品 lyj
    curLoc(newVal) {
      this.initIdxPage()
    },
  },
  methods: {
    //根据参数跳转到产品详情页面 lyj
    clickJump(productId) {
      const timejump = 1
      if (!this.timer) {
        //alert(productId);
        this.count = timejump
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= timejump) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            this.count = 100
            //跳转的页面写在此处
            this.$router.push({
              name: 'productDetail',
              params: { prodId: productId },
            })
          }
        }, 200)
      }
    },

    //根据参数跳转到新闻咨询详情页面 lyj
    clickJumpToNews(id) {
      const timejump = 1
      if (!this.timer) {
        //alert(id);
        this.count = timejump
        this.show = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= timejump) {
            this.count--
          } else {
            this.show = true
            clearInterval(this.timer)
            this.timer = null
            this.count = 100
            //跳转的页面写在此处
            this.$router.push({ name: 'news-detail', params: { newsId: id } })
          }
        }, 200)
      }
    },

    newsDetail(news) {
      this.$router.push({
        name: 'news-detail',
        params: { newsId: news.id },
      })
    },
    async initIdxPage() {
      // ad
      const re = await API.fetchADs(5)
      if (re.data.result && re.data.result.length === 0) {
        // this.carouselArr = [{ pics: require('@/assets/image/default_img.jpg'), id: 8888, uri: '' }]
      } else {
        const tmpArr = re.data.result
        tmpArr.forEach((i) => {
          i.pics = this.tImgUrl(i.pics)
        })
        this.carouselArr = tmpArr
      }
      // 热门资讯,最前面4个
      const newsRe = await API.fetchLatestNews()
      this.hotNewsArr = newsRe.data.result.records.slice(0, 4)
      this.hotNewsArr.forEach((i) => {
        i.pics = i.pics.split(',')
      })

      // 最新培训
      const trainRe = await API.fetchLatestTrain({
        cityCode: this.curLoc[1],
      })
      this.latestTrainList = trainRe.data.result.list

      console.log(this.latestTrainList, 'this.latestTrainList')

      // 推荐商品
      const recmdRe = await API.fetchRecmdGoods({
        cityCode: this.curLoc[1],
      })


      this.recmdList = recmdRe.data.result.slice(0, 11)
      this.recmdList=this.recmdList.filter(a=>{
        return a.id!="1635122958450065409"
      })
      //console.log("index:recmdList")
       console.log(this.recmdList,"dddddd")
    },
    goADLink(i) {
      if (i.uri) {
        //记录广告点击 lyj
        //alert(i.id)
        const re = API.recordBrowse({ id: i.id, type: 6 })
        // this.$router.push({ name: 'productDetail', params: { prodId: 1282566455077920770} })
        window.open(`${i.uri}`, '_blank')
        //window.open(`http://192.168.1.214:9001/js-esp-pc/index/1282566455077920770`, '_blank')
        //window.open(`http://192.168.1.214:9001/js-esp-pc/index/180086/2`, '_blank')
      }
    },
    toLeftImg(val) {
      if (val === 'right') {
        this.$refs.cardShow.next()
      } else {
        this.$refs.cardShow.prev()
      }
    },
    goMore() {
      this.$router.push({ name: 'qypx' })
    },
    goGdsDetail(i) {
      this.$router.push({ name: 'productvideo', params: { prodId: i.id } })
    },
  },
  components: {
    Carousel,
    Slide,
    IdxSec,
    ProductList,
  },
}
</script>

<style lang="stylus">
.first_m {
  width: 1200px;
  height: 200px;
  background-color: #ebb47f;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.3);
  border-radius: 20px;
  margin: auto;
   margin-top: 20px;
  z-index: 100;
  position: relative;
  display: flex;
  align-items: center;
  background-size: contain;
  background-repeat: no-repeat;

  .idx-l-item {
    center();
    width: 25%;
    height: 139px;
    position: relative;
    cursor: pointer;

    .idx-l-item-w {
      text-align: center;

      img {
        display: inline-block;
        width: 100px;
        height: 100px;
      }

      .idx-l-i-txt {
        text-align: center;
        width: 100%;
        font-size: 20px;
        color: #ffffff;
        font-family: AdobeHeitiStd-Regular;
        margin-top: 16px;
      }
    }
  }
}

.base-index {
  background-color: #ffffff;

  .need-help {
    position: fixed;
    right: 1.5%;
    bottom: 19%;
    height: 100px;
    width: 100px;
    font-size: 0;
    z-index: 101;

    img {
      display: inline-block;
      height: 100%;
      width: 100%;
    }
  }

  .carousel-wrapper {
    height: 740px;
    width: 100%;
    max-width: 100%;
    margin: 0 auto;

    .el-carousel__indicators--horizontal {
      bottom: 30px;
    }

    .el-carousel__indicator--horizontal .el-carousel__button {
      width: 10px;
      height: 10px;
      background: transparent;
      border: 1px solid #ffffff;
      border-radius: 50%;
      opacity: 0.5;
    }

    .el-carousel__indicator--horizontal.is-active .el-carousel__button {
      width: 10px;
      height: 10px;
      background: #ffffff;
      border-radius: 50%;
      opacity: 1;
    }

    .slide-cls {
      height: 100%;
      margin: 0 auto;
      padding: 0;
    }

    .VueCarousel-pagination {
      z-index: 100;
      margin-top: -80px;

      .VueCarousel-dot {
        width: 50px !important;
        height: 4px !important;
        border-radius: 30px !important;
      }
    }

    img {
      overflow: hidden;
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }

  .idx-news-wr {
    width: 1200px;
    margin: 0 auto;
    background-color: #ffffff;
    margin-top: 100px;

    .newstext {
      font-family: AdobeHeitiStd-Regular;
      text-align: center;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
    }

    .news_h {
      margin: 0 auto;
      margin-top: 10px;
      width: 138px;
      height: 1px;
      background-color: #ff7a00;
    }

    .newset {
      margin-top: 10px;
      text-align: center;
      font-family: AdobeHeitiStd-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
    }

    .news-content {
      margin-top: 50px;
      background-color: #ffffff;
      margin-bottom: 20px;

      .idx-nc-l, .idx-nc-r {
        height: 460px;
      }

      .idx-nc-l {
        border-radius: 6px;
        background-color: bg-color-ff;
        padding: 26px 40px;
        box-sizing: border-box;

        .nc-h-l-img-w {
          font-size: 0;

          img {
            display: inline-block;
            width: 100%;
            height: 150px;
          }
        }

        .nc-h-l-title {
          color: theme-color;
          font-size: 22px;
          margin: 30px 0;
          ellipsis();
        }

        .nc-h-l-brief {
          color: #8C8C8C;
          line-height: 24px;
        }
      }

      .idx-nc-r {
        columnCenter();
        justify-content: flex-start;

        .idx-h-r-item {
          width: 100%;
          height: 140px;
          margin: 10px 0;
          background-color: bg-color-ff;
          padding: 20px 28px;
          box-sizing: border-box;
          position: relative;

          .idx-h-r-i-title {
            max-width: 320px;
            margin-bottom: 20px;
            font-size: 20px;
          }

          .idx-h-r-i-brief {
            color: #8C8C8C;
            line-height: 24px;
          }

          .idx-h-r-i-date {
            position: absolute;
            right: 28px;
            top: 20px;
            font-size: 14px;
            color: #999999;
          }
        }
      }
    }

    .links {
      background-color: bg-color-ff;
      margin-bottom: -90px;
      height: 180px;
      display: flex;

      .idx-l-item {
        center();
        flex: 1 1 25%;
        // height 100%
        position: relative;

        .idx-l-item-w {
          width: 80px;

          img {
            display: inline-block;
            width: 100%;
            height: 100%;
          }

          .idx-l-i-txt {
            text-align: center;
            width: 120px;
            margin-left: -20px;
            font-size: 14px;
          }
        }
      }
    }
  }

  .w_youshi {
    width: 100%;
    height: 550px;
    margin-top: 150px;
    background-size: cover;
    background-repeat: no-repeat;

    .newstext {
      font-family: AdobeHeitiStd-Regular;
      text-align: center;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
      padding-top: 100px;
    }

    .news_h {
      margin: 0 auto;
      margin-top: 10px;
      width: 138px;
      height: 1px;
      background-color: #ff7a00;
    }

    .newset {
      margin-top: 10px;
      text-align: center;
      font-family: AdobeHeitiStd-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
      height: 34px;
    }

    .train-content {
      width: 1200px;
      margin: 0 auto;
      margin-top: 50px;
      display: flex;
      justify-content: space-between;

      .item_imgclass {
        width: 180px;
        height: 180px;

        img {
          width: 180px;
          height: 180px;
        }
      }
    }
  }

  .zxpx {
    width: 100%;
    height: 1010px;
    margin-top: 150px;
    background-size: cover;
    background-repeat: no-repeat;

    .newstext {
      font-family: AdobeHeitiStd-Regular;
      text-align: center;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
      padding-top: 100px;
    }

    .news_h {
      margin: 0 auto;
      margin-top: 10px;
      width: 138px;
      height: 1px;
      background-color: #ff7a00;
    }

    .newset {
      margin-top: 10px;
      text-align: center;
      font-family: AdobeHeitiStd-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
    }
  }

  .idx-train-wr {
    // width: 1200px;
    // margin: 0 auto;
    margin-top: 100px;
    background-color: #ffffff;

    .newstext {
      font-family: AdobeHeitiStd-Regular;
      text-align: center;
      font-size: 36px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
    }

    .news_h {
      margin: 0 auto;
      margin-top: 10px;
      width: 138px;
      height: 1px;
      background-color: #ff7a00;
    }

    .newset {
      margin-top: 10px;
      text-align: center;
      font-family: AdobeHeitiStd-Regular;
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #ff7a00;
    }

    .train-content {
      width: 1240px;
      margin: 0 auto;
      margin-top: 50px;
    }
  }

  .idx-remd-wr {
    padding-bottom: 60px;
  }
}

.z_lunbo {
  .el-carousel__mask {
    background-color: #000000;
    box-shadow: 0px 0px 30px 0px rgba(0, 0, 0, 0.5);
    border-radius: 8px;
  }

  width: 1200px;
  height: 650px;
  margin: auto;
  margin-top: 50px;
  position: relative;

  .next_l {
    width: 50px;
    height: 150px;
    border-radius: 25px;
    border: solid 4px #ff7a00;
    cursor: pointer;
    display: flex;
    align-items: center;
  }

  .lunbo_l {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    margin: auto;
  }

  .lunbo_r {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    margin: auto;
  }

  .jiantou {
    font-size: 50px;
    color: #ff7a00;
  }
}

.seemore {
  width: 200px;
  height: 30px;
  margin: auto;
  background-color: #ff7a00;
  border-radius: 6px;
  cursor: pointer;
  margin-top: 50px;
  font-family: AdobeHeitiStd-Regular;
  font-size: 20px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 30px;
  letter-spacing: 0px;
  color: #ffffff;
  padding: 5px 0;
  text-align: center;
}
</style>
